export default __webpack_public_path__ + "b0bba6c828babf9dff23c7d6938b9d27.svg";